/**
 * Picking up a session the OAuth callback left in the URL fragment.
 *
 * The callback cannot post a body — the browser arrives there by navigation —
 * so the token comes back on the address. It is in the fragment rather than
 * the query string because a fragment is never sent to a server and never
 * written to an access log, and a session token in a web server's log is a
 * session anyone with the log can use.
 *
 * It is taken out of the address bar immediately, with `replaceState` so the
 * back button does not return to a URL still carrying it.
 */
export default function consumeOauthReturn() {
  if (typeof window === 'undefined') return null;
  const raw = window.location.hash || '';
  if (!raw.includes('customer_token=')) return null;

  let token = null;
  try {
    token = new URLSearchParams(raw.replace(/^#/, '')).get('customer_token');
  } catch (_) {
    return null;
  }
  if (!token) return null;

  try {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  } catch (_) { /* a stale address bar is better than throwing here */ }

  return token;
}
